export default __webpack_public_path__ + "static/media/gestion-integral-de-riesgos-y-cobranzas.31bd3be4.pdf";